import { RoofSide } from "building-types/settings/roofTypes";
import { WallType } from "building-types/walls/wallEnums";
import type { PolyLine2 } from "geom/polyLine2Types";

export interface RoofWallEdge {
  readonly edge: PolyLine2 | null;
  readonly wallType: WallType;
  readonly forceAddWall: boolean;
  readonly roofSide: RoofSide;
  readonly offset: number;
}

export interface RoofWallExtension {
  readonly edgeIndex: number;
  readonly extension: number;
}

export interface RoofWallSystemPerimeter {
  readonly perimeter: PolyLine2;
  readonly roofWallEdges: RoofWallEdge[];
}

export function roofWallEdgeNew(
  edge: PolyLine2 | null,
  wallType: WallType = WallType.VOID,
  forceAddWall: boolean = false,
  roofSide: RoofSide = RoofSide.INVALID,
  offset: number = 0,
): RoofWallEdge {
  return {
    edge,
    wallType,
    forceAddWall,
    roofSide,
    offset,
  };
}

export function roofWallExtensionNew(edgeIndex: number, extension: number): RoofWallExtension {
  return {
    edgeIndex,
    extension,
  };
}

export function roofWallSystemPerimeterNew(
  perimeter: PolyLine2,
  roofWallEdges: RoofWallEdge[],
): RoofWallSystemPerimeter {
  return {
    perimeter,
    roofWallEdges,
  };
}
